import { SET_EDIT_MODE, RESET_EDIT_MODE } from './types';

// Action creator to set edit mode to true
export const setEditMode = () => ({
  type: SET_EDIT_MODE,
});

// Action creator to reset edit mode to false
export const resetEditMode = () => ({
  type: RESET_EDIT_MODE,
}); 